import App from "./App"
import React from "react";
import ReactDOM from "react-dom/client";
import "./main.css"

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el);


root.render (<App/>)

